<template>
	<div>
		<h5
			class="sec-hd"
		>
			We respect your privacy, we'll only email you if better quotes are available.
		</h5>
		<h2 class="primary-hd">
			What's your <b>email address</b> ?
		</h2>
		<div class="row">
			<div class="form-input col-md-8">
				<validate-field
					:on-change="onFieldChange"
					:field-value="quote.email || ''"
					:focus="true"
					field="email"
					field-text="email address"
					field-ph="name@example.com"
				/>
			</div>
			<div class="form-button col-md-4">
				<slot name="submitButton" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

import validateInput from '@/common/validate';

export default {
	name: 'QuoteEmail',

	components: {
		'validate-field': validateInput,
	},

	data() {
		return {
			step: 6,
		};
	},

	computed: {
		...mapState({
			quote: state => state.quote,
		}),

		isValid() {
			if (this.validate.email.isValid) {
				return true;
			}

			return false;
		},

		validate() {
			return this.$store.state.validator;
		},
	},

	created() {
		if (!this.quote.firstName) {
			this.$router.push({ name: 'Quote-Name' });
		}
	},

	mounted() {
		const quote = this.quote;

		this.$store.dispatch('progress/updateProgress', this.step);

		if (quote.email && quote.email.length) {
			this.$store.commit('validator/SET_VALID_STATE', {
				field: 'email',
				isValid: true,
			});
		}
	},

	methods: {
		onFieldChange(field, model, isValid) {
			this.$log.debug(`field: ${field} | model: ${model} | ${isValid}`);

			if (isValid) {
				this.$store.dispatch('quote/update', {
					[field]: model.trim(),
				});
			}
		},
	},
};
</script>

<style lang="scss">

</style>
